<ng-container *ngIf='!isLoading, else showLoading'>
  <div class="row mb--md">
    <div class='column--12 align-right'>
      <button mat-raised-button color="primary" (click)='openTourDrawer()' [disabled]='!canEdit'>
        Create Tour
      </button>
    </div>
  </div>

  <mat-card>
    <mat-card-content>
      <ng-container *ngIf="tours?.length > 0, else noTours">
        <div class='responsive-table'>
          <table mat-table [dataSource]="tours" class='mat-elevation-z0'>
            <!-- Name Column -->
            <ng-container matColumnDef="name" style='width: 50%'>
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let tour">{{ tour.name }}</td>
            </ng-container>

            <!-- Page Column -->
            <ng-container matColumnDef="page">
              <th mat-header-cell *matHeaderCellDef>Page</th>
              <td mat-cell *matCellDef="let tour">{{ tour.pageSlug || 'N/A' }}</td>
            </ng-container>

            <!-- Type Column -->
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef style='width: 150px'>Type</th>
              <td mat-cell *matCellDef="let tour">
                {{ tour.multipage ? 'Multi-page' : 'Single-page' }}
              </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef style='width: 100px'>Status</th>
              <td mat-cell *matCellDef="let tour">
                <mat-chip
                  class='chip-status'
                  [ngClass]="tour.isActive ? 'active' : 'inactive'"
                  (click)='tour.isActive ? deactivateTour(tour) : activateTour(tour)'
                  [disabled]='!canEdit'
                >
                  {{ tour.isActive ? 'Active' : 'Inactive' }}
                </mat-chip>
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef style='width: 150px'></th>
              <td mat-cell *matCellDef="let tour">
                <button mat-icon-button color="primary" (click)='editTour(tour)' [disabled]='!canEdit'>
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteTour(tour)" [disabled]='!canEdit'>
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
          </table>
        </div>
      </ng-container>
      <ng-template #noTours>
        <div class='row justify-content-center mt--lg'>
          <div class='column--12 column-md--4 align-center'>
            <img src='{{ CDN_URL }}/admin/images/empty_animated.svg' width='250' />
            <p>No tours found.</p>
          </div>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</ng-container>
<ng-template #showLoading>
  <div class='align-center mt--lg'>
    <app-loading></app-loading>
  </div>
</ng-template>
